var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-player"},[(_vm.list)?_c('music',{attrs:{"theme":"#5b246d","music":_vm.song,"list":_vm.list,"listFolded":"","volume":1,"controls":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }